<section id="mass-os-client" class="mass-os-client mass-os-client-card">
  <header class="mass-os-card__header">
    <div class="mass-os-card__icon" aria-hidden="true">
      <mat-icon>business</mat-icon>
    </div>
    <div class="mass-os-card__text">
      <h3 class="mass-os-card__title">Cliente</h3>
      <p class="mass-os-card__context">
        Selecciona los clientes cuyos files se incluirán en la generación.
      </p>
    </div>
  </header>

  <div class="mass-os-field-group">
    <label class="mass-os-label"
      >Cliente <span class="mass-os-label__req">*</span></label
    >
    <!-- TODO: reactivar cuando la API diferencie B2C / B2B
    <mat-radio-group
      class="mass-os-client__mode"
      [value]="clientMode"
      (change)="onClientModeChange($event.value)"
    >
      <mat-radio-button value="b2c">B2C (Business to Client)</mat-radio-button>
      <mat-radio-button value="b2b"
        >B2B (Business to Business)</mat-radio-button
      >
    </mat-radio-group>
    -->
  </div>

  <!-- TODO: reactivar sección B2C cuando la API la soporte
  <div class="mass-os-client__sources mass-os-b2c" *ngIf="clientMode === 'b2c'">
    ...
  </div>
  -->

  <div class="mass-os-client__sources mass-os-b2b">
    <label class="mass-os-label">
      Listado de Clientes <span class="mass-os-label__req">*</span>
    </label>

    <div class="mass-os-b2b__columns">
      <div class="mass-os-b2b__list">
        <div class="mass-os-b2b__search">
          <input
            type="text"
            placeholder="Buscar"
            autocomplete="off"
            [value]="b2bSearch"
            (input)="onB2bSearchChange($any($event.target).value)"
          />
          <i-tabler name="search" class="mass-os-b2b__search-icon"></i-tabler>
        </div>

        <mat-checkbox
          class="mass-os-client__all mass-os-b2b__select-all"
          [checked]="allVisibleB2bSelected"
          [indeterminate]="someVisibleB2bSelected"
          (change)="onToggleAllVisibleB2b($event.checked)"
        >
          Seleccionar todos
        </mat-checkbox>

        <div class="mass-os-b2b__options">
          <div
            class="mass-os-b2b__loading"
            *ngIf="isLoadingClients"
          >
            <mat-progress-spinner
              diameter="20"
              mode="indeterminate"
            ></mat-progress-spinner>
            <span>Cargando clientes...</span>
          </div>

          <mat-checkbox
            *ngFor="
              let client of filteredB2bClients;
              trackBy: trackByOption
            "
            [checked]="b2bClientIds.includes(client.id)"
            (change)="onToggleB2b(client.id, $event.checked)"
          >
            {{ client.name }}
          </mat-checkbox>

          <span
            class="mass-os-b2b__empty"
            *ngIf="!isLoadingClients && !filteredB2bClients.length"
          >
            Sin resultados para "{{ b2bSearch }}"
          </span>
        </div>
      </div>

      <div class="mass-os-b2b__selected">
        <span class="mass-os-b2b__col-title">Clientes seleccionados</span>
        <div class="mass-os-b2b__chips-box">
          <span
            class="mass-os-b2b__chip"
            *ngFor="let client of selectedB2bClients; trackBy: trackByOption"
          >
            <i-tabler
              name="user"
              class="mass-os-b2b__chip-avatar"
              aria-hidden="true"
            ></i-tabler>
            <span class="mass-os-b2b__chip-name">{{ client.name }}</span>
            <button
              type="button"
              class="mass-os-b2b__chip-remove"
              [attr.aria-label]="'Quitar cliente ' + client.name"
              (click)="onToggleB2b(client.id, false)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </span>

          <span
            class="mass-os-b2b__empty"
            *ngIf="!selectedB2bClients.length"
          >
            Sin clientes seleccionados
          </span>
        </div>
      </div>
    </div>

    <span class="mass-os-client__error" role="alert">{{ b2bError }}</span>
  </div>
</section>
